import React, { useEffect, useState } from "react";
import { Tabs, Tab, Box } from "@mui/material";

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

type CustomTabsProps = {
  tabs: {
    label: string;
    content: React.ReactNode;
  }[];
  initialTab: number;
  onTabChange: (index: number) => void;
};

const CustomTabs: React.FC<CustomTabsProps> = ({ tabs, initialTab, onTabChange }) => {
  const [value, setValue] = useState(initialTab);

  useEffect(() => {
    setValue(initialTab);
  }, [initialTab]);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    onTabChange(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="custom tabs"
        variant="fullWidth"
        sx={{
          "& .MuiTab-root": {
            textTransform: "capitalize",
          },
        }}
      >
        {tabs.map((tab, index) => (
          <Tab label={tab.label} key={index} />
        ))}
      </Tabs>
      {tabs.map((tab, index) => (
        <TabPanel value={value} index={index} key={index}>
          {tab.content}
        </TabPanel>
      ))}
    </Box>
  );
};

export default CustomTabs;

